<template>
    <section v-if="newBizParam">

        <!-- 规则1 start-->
        <div class="rule">
            <span class="rule-txt">规则1：</span>
            <el-checkbox  style="margin-right: 10px;" @change="changeCheck(1);$emit('changeData',newBizParam)" v-model="newBizParam.dayItemBelongSameCustomer.enabled"></el-checkbox>
            <div :class="!newBizParam.dayItemBelongSameCustomer.isSamePerson&&newBizParam.dayItemBelongSameCustomer.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayItemBelongSameCustomer.enabled" class="w130" v-model="newBizParam.dayItemBelongSameCustomer.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt">允许同天在同一家医院提交科室数累计最多<span :class="!newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sumLimitMax&&newBizParam.dayItemBelongSameCustomer.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sumLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                :min="1" :maxlength="7"  :disabled="!newBizParam.dayItemBelongSameCustomer.enabled"></el-input></span>个，但每个科室最多允许提交<span :class="!newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sameLimitMax&&newBizParam.dayItemBelongSameCustomer.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sameLimitMax"  @input="$forceUpdate();"  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                :min="1" :maxlength="7"  :disabled="!newBizParam.dayItemBelongSameCustomer.enabled"></el-input></span>次</span>
            <p class="tips" v-if="newBizParam.dayItemBelongSameCustomer.enabled&&(!newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sameLimitMax||!newBizParam.dayItemBelongSameCustomer.ruleItemList[0].sumLimitMax)&&isOpenCheck">请将规则填写完整</p>
        </div>
        <!-- 规则1 end-->

         <!-- 规则2 start-->
         <div class="rule">
            <span class="rule-txt">规则2：</span>
            <el-checkbox  style="margin-right: 10px;" @change="changeCheck(2);$emit('changeData',newBizParam)" v-model="newBizParam.dayCustomerSumNotSame.enabled"></el-checkbox>
            <div :class="!newBizParam.dayCustomerSumNotSame.isSamePerson&&newBizParam.dayCustomerSumNotSame.enabled&&isOpenCheck?'red-border':''">
                <el-select  @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.dayCustomerSumNotSame.enabled" class="w130" v-model="newBizParam.dayCustomerSumNotSame.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt">同天提交的医院数累计最多<span :class="!newBizParam.dayCustomerSumNotSame.ruleItemList[0].sumLimitMax&&newBizParam.dayCustomerSumNotSame.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="newBizParam.dayCustomerSumNotSame.ruleItemList[0].sumLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                :min="1" :maxlength="7"  :disabled="!newBizParam.dayCustomerSumNotSame.enabled"></el-input></span>家</span>
            <p class="tips" v-if="newBizParam.dayCustomerSumNotSame.enabled&&!newBizParam.dayCustomerSumNotSame.ruleItemList[0].sumLimitMax&&isOpenCheck">请将规则填写完整</p>
        </div>
        <!-- 规则2 end-->

        <!-- 规则3 start-->
        <div class="rule">
            <span class="rule-txt">规则3：</span>
            <el-checkbox style="margin-right: 10px;"  @change="changeCheck(3);$emit('changeData',newBizParam)" v-model="newBizParam.monthItemSameSum.enabled"></el-checkbox>
            <div :class="!newBizParam.monthItemSameSum.isSamePerson&&newBizParam.monthItemSameSum.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.monthItemSameSum.enabled" class="w130" v-model="newBizParam.monthItemSameSum.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt">同月同一家医院的同一个科室有需要提交多次的，最多提交<span :class="!newBizParam.monthItemSameSum.ruleItemList[0].sumLimitMax&&newBizParam.monthItemSameSum.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="newBizParam.monthItemSameSum.ruleItemList[0].sumLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                :min="1" :maxlength="7"  :disabled="!newBizParam.monthItemSameSum.enabled"></el-input></span>次</span>
            <p class="tips" v-if="newBizParam.monthItemSameSum.enabled&&!newBizParam.monthItemSameSum.ruleItemList[0].sumLimitMax&&isOpenCheck">请将规则填写完整</p>
        </div>
        <!-- 规则3 end-->

        <!-- 规则4 start-->
        <div class="rule">
            <span class="rule-txt">规则4：</span>
            <el-checkbox style="margin-right: 10px;"  @change="changeCheck(4);$emit('changeData',newBizParam)" v-model="newBizParam.monthCustomerSameSum.enabled"></el-checkbox>
            <div :class="!newBizParam.monthCustomerSameSum.isSamePerson&&newBizParam.monthCustomerSameSum.enabled&&isOpenCheck?'red-border':''">
                <el-select @change="$emit('changeData',newBizParam)" :disabled="!newBizParam.monthCustomerSameSum.enabled" class="w130" v-model="newBizParam.monthCustomerSameSum.isSamePerson" placeholder="请选择" clearable>
                    <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <span class="txt">同月同一家医院需要提交多次的，同一家医院最多提交<span :class="!newBizParam.monthCustomerSameSum.ruleItemList[0].sumLimitMax&&newBizParam.monthCustomerSameSum.enabled&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="newBizParam.monthCustomerSameSum.ruleItemList[0].sumLimitMax" @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                :min="1" :maxlength="7"  :disabled="!newBizParam.monthCustomerSameSum.enabled"></el-input></span>次</span>
            <p class="tips" v-if="newBizParam.monthCustomerSameSum.enabled&&!newBizParam.monthCustomerSameSum.ruleItemList[0].sumLimitMax&&isOpenCheck">请将规则填写完整</p>
        </div>
        <!-- 规则4 end-->

        <!-- 规则5 start-->
        <div class="rule">
            <span class="rule-txt">规则5：</span>
            
            <el-checkbox style="margin-right: 10px;"  @change="$emit('changeData',newBizParam)" v-model="newBizParam.dataRepeatIntercept"></el-checkbox>
           
            <span class="txt">同企业所有人同一天内，提交同医院同科室的数据不可重复</span>
            <el-tooltip class="item" effect="light" placement="top-start">
                <div slot="content">同企业所有人中，提交<i class="tips">同医院、同科室</i>的数据进行拦截提示"该医院科室当日已提交，不可重复提交"。</div>
                <i class="el-icon-question" style="color: #606266;"></i>
            </el-tooltip>  
        </div>
        <!-- 规则5 end-->
    </section>
</template>
  
<script>
export default {
    props: ['bizParam1'],
    data() {
        return {
            isOpenCheck:false,
            isSamePersonOption:[
                {
                    value: 'Y',
                    label: '同一人员',
                },
                {
                    value: 'N',
                    label: '不同人员',
                },
            ],
            newBizParam:null

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
                if (!this.$route.query.guid && this.$route.query.type != 3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                this.$forceUpdate();
            }
        }
    },
    created() {
        if (this.$route.query.guid || this.$route.query.type == 3) return
        this.newBizParam = this.bizParam1;
        this.changeCheck(0);

    },
    methods: {
        changeCheck(i) {
            // 规则1
            if (!this.newBizParam.dayItemBelongSameCustomer.enabled && (i == 1 || i == 0)) {
                this.newBizParam.dayItemBelongSameCustomer = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "13",
                            "sameLimitMax": null,
                            "sumLimitMax": null
                        }
                    ]
                }
            }
            // 规则2
            if (!this.newBizParam.dayCustomerSumNotSame.enabled && (i == 2 || i == 0)) {
                this.newBizParam.dayCustomerSumNotSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null
                        },
                    ]
                }
            }
            //规则3
            if (!this.newBizParam.monthItemSameSum.enabled && (i == 3 || i == 0)) {
                this.newBizParam.monthItemSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "13",
                            "sumLimitMax": null
                        }
                    ]
                }
            }
            //规则4
            if (!this.newBizParam.monthCustomerSameSum.enabled && (i == 4 || i == 0)) {
                this.newBizParam.monthCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null
                        }
                    ]
                }
            }
            console.log(this.newBizParam)
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let { dayCustomerSumNotSame, dayItemBelongSameCustomer, monthItemSameSum, monthCustomerSameSum } = this.newBizParam;
            //规则1 校验
            if (dayItemBelongSameCustomer.enabled && (!dayItemBelongSameCustomer.ruleItemList[0].sameLimitMax || !dayItemBelongSameCustomer.ruleItemList[0].sumLimitMax)) return;
            //规则2 校验
            if (dayCustomerSumNotSame.enabled && !dayCustomerSumNotSame.ruleItemList[0].sumLimitMax) return;
            //规则3 校验
            if (monthItemSameSum.enabled && !monthItemSameSum.ruleItemList[0].sumLimitMax) return;
            //规则4 校验
            if (monthCustomerSameSum.enabled && !monthCustomerSameSum.ruleItemList[0].sumLimitMax) return;
            return true;
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}
.rule-txt{
    width: 52px;
    flex-shrink: 0;
}
.w260{
    width: 260px; 
}

.w130 {
    width: 130px;
}

.rule-input-box {
    width: 90px;
}
.txt{
    margin:0 10px;
}
.theme-color{
    color:#4FA1A4;
    font-style: normal;
}
.rule-child{
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
}
.tips{
    color:red;
    font-size: 12px;
}
.red-border{
    border: 1px solid red;
    border-radius: 4px;
}
.red-border /deep/ .el-input__inner{
    border: 0 none;
}
span{
    display: inline-block;
}
</style>
  